export const chapter4Translations = {
  name: "Capítulo 4: Crucificação e Ressurreição",
  description: "Siga a história da paixão, morte e ressurreição de Jesus",
  spiritualWisdom: "A cruz é o símbolo do triunfo definitivo do amor e da vitória sobre o pecado. A ressurreição nos oferece a promessa de uma nova vida em Cristo.",
  
  levels: {
    40: {
      name: "A Prisão",
      challenge: "Descubra a prisão de Jesus no Getsêmani",
      
      questions: {
        easy: {
          question: "Em qual jardim Jesus foi preso?",
          options: ["Getsêmani", "Éden", "Oliveiras", "Nazaré"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "Qual sinal Judas usou para trair Jesus?",
          options: ["Um aperto de mão", "Um beijo", "Uma palavra", "Um gesto"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Qual discípulo cortou a orelha do servo do sumo sacerdote com sua espada?",
          options: ["Tiago", "João", "Pedro", "André"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Getsêmani é um jardim no sopé do Monte das Oliveiras",
        "Judas traiu Jesus por 30 moedas de prata",
        "Jesus curou milagrosamente a orelha do servo"
      ],
      
      funFacts: [
        "Getsêmani significa 'prensa de azeite', onde o óleo de oliva era produzido",
        "A prisão de Jesus aconteceu no meio da noite",
        "Jesus foi pacificamente, pedindo aos seus discípulos para não resistir com violência"
      ]
    },

    41: {
      name: "A Negação de Pedro",
      challenge: "Descubra como Pedro negou Jesus três vezes",
      
      questions: {
        easy: {
          question: "Quantas vezes Pedro negou Jesus?",
          options: ["Uma vez", "Duas vezes", "Três vezes", "Quatro vezes"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "O que aconteceu após a terceira negação de Pedro?",
          options: ["O sol nasceu", "O galo cantou", "Um relâmpago brilhou", "Houve um terremoto"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Onde Pedro estava quando negou Jesus?",
          options: ["No templo", "No pátio do sumo sacerdote", "No palácio de Pilatos", "No Getsêmani"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Jesus havia predito a negação de Pedro",
        "Pedro chorou amargamente após perceber o que tinha feito",
        "Tudo aconteceu na mesma noite"
      ],
      
      funFacts: [
        "Jesus disse 'Antes que o galo cante, três vezes me negarás'",
        "A negação de Pedro é um exemplo poderoso da fraqueza humana e do perdão divino",
        "Pedro mais tarde se tornou um grande líder da Igreja"
      ]
    },

    42: {
      name: "Jesus diante de Pilatos",
      challenge: "Descubra o julgamento de Jesus diante do governador romano",
      
      questions: {
        easy: {
          question: "Quem era Pilatos?",
          options: ["Um discípulo", "O governador romano", "O sumo sacerdote", "Um fariseu"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "O que Pilatos não encontrou em Jesus?",
          options: ["Sabedoria", "Culpa", "Coragem", "Poder"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "O que Pilatos fez para simbolizar sua inocência?",
          options: ["Lavou as mãos", "Rasgou sua veste", "Jejuou", "Orou"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Pilatos queria libertar Jesus",
        "A multidão exigiu a crucificação de Jesus",
        "Pilatos cedeu à pressão política"
      ],
      
      funFacts: [
        "A esposa de Pilatos o advertiu para não fazer nada contra Jesus",
        "Lavar as mãos era um símbolo de inocência na tradição judaica",
        "A decisão de Pilatos demonstrou o fracasso da justiça humana"
      ]
    },

    43: {
      name: "Barrabás ou Jesus",
      challenge: "Descubra a escolha da multidão por Barrabás",
      
      questions: {
        easy: {
          question: "Quem era Barrabás?",
          options: ["Um discípulo", "Um bandido", "Um sacerdote", "Um rei"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "O que Pilatos podia fazer durante a festa judaica?",
          options: ["Libertar um prisioneiro", "Perdoar impostos", "Oferecer um banquete", "Fechar o templo"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Quem a multidão escolheu?",
          options: ["Jesus", "Barrabás", "Ambos", "Ninguém"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Era a festa da Páscoa",
        "A multidão pediu que Jesus fosse crucificado",
        "Barrabás era um assassino e rebelde"
      ],
      
      funFacts: [
        "O nome Barrabás significa 'filho do pai'",
        "A libertação de Barrabás é um símbolo do sacrifício de Cristo",
        "Todos nós somos Barrabás, libertados pelo sacrifício de Jesus"
      ]
    },

    44: {
      name: "Flagelação e Coroa de Espinhos",
      challenge: "Descubra o sofrimento de Jesus",
      
      questions: {
        easy: {
          question: "O que os soldados colocaram na cabeça de Jesus?",
          options: ["Uma coroa de ouro", "Uma coroa de espinhos", "Uma guirlanda de flores", "Um turbante"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Como os soldados zombaram de Jesus?",
          options: ["Chamando-o de rei", "Apedrejando-o", "Prendendo-o", "Ignorando-o"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "O que o chicote romano continha?",
          options: ["Tiras de couro", "Pedaços de osso e metal", "Apenas madeira", "Corda"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "A flagelação era uma punição romana brutal",
        "Os soldados vestiram Jesus com um manto púrpura",
        "Jesus suportou tudo isso em silêncio"
      ],
      
      funFacts: [
        "A coroa de espinhos simboliza a maldição do pecado",
        "A cor púrpura era uma cor real, usada como escárnio",
        "O sofrimento de Jesus cumpre as profecias de Isaías"
      ]
    },

    45: {
      name: "Caminho para o Gólgota",
      challenge: "Descubra como Jesus carregou a cruz",
      
      questions: {
        easy: {
          question: "O que Jesus carregou?",
          options: ["Uma bandeira", "Uma cruz", "Uma coroa", "Uma espada"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Quem ajudou Jesus a carregar a cruz?",
          options: ["Pedro", "João", "Simão de Cirene", "José"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "O que significa Gólgota?",
          options: ["Monte santo", "Lugar da caveira", "Lugar de paz", "Lugar de justiça"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Jesus caiu várias vezes por fraqueza",
        "Mulheres choravam ao longo do caminho",
        "A procissão atravessou a cidade"
      ],
      
      funFacts: [
        "A cruz pesava cerca de 40-50 kg",
        "O Gólgota ficava fora dos muros da cidade",
        "Simão de Cirene veio da África"
      ]
    },

    46: {
      name: "A Crucificação",
      challenge: "Descubra a crucificação de Jesus",
      
      questions: {
        easy: {
          question: "Com quantas outras pessoas Jesus foi crucificado?",
          options: ["Nenhuma", "Uma", "Duas", "Três"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "O que Jesus disse na cruz: 'Pai, ___ a eles'?",
          options: ["Salva", "Perdoa", "Pára", "Pune"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Qual era a inscrição na cruz?",
          options: ["Pecador", "Rei dos Judeus", "Rebelde", "Profeta"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Jesus foi crucificado na terceira hora do dia",
        "Os soldados lançaram sortes pelas suas vestes",
        "Jesus pronunciou sete palavras da cruz"
      ],
      
      funFacts: [
        "A inscrição estava escrita em três línguas: hebraico, latim e grego",
        "Um dos ladrões se arrependeu no último momento",
        "Jesus confiou sua mãe aos cuidados de João"
      ]
    },

    47: {
      name: "A Morte de Jesus",
      challenge: "Descubra as últimas horas de Jesus",
      
      questions: {
        easy: {
          question: "O que aconteceu no momento da morte de Jesus?",
          options: ["O sol brilhou mais forte", "Trevas cobriram a terra", "Choveu", "Apareceu um arco-íris"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "O que se rasgou no templo?",
          options: ["O chão", "O véu", "A parede", "O teto"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Quais foram as últimas palavras de Jesus?",
          options: ["Está consumado", "Tenho sede", "Pai, nas tuas mãos entrego o meu espírito", "Por que me abandonaste"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "As trevas duraram três horas",
        "Um soldado perfurou o lado de Jesus com uma lança",
        "Um centurião disse 'Verdadeiramente este era Filho de Deus'"
      ],
      
      funFacts: [
        "O véu do templo se rasgou de alto a baixo, não por mão humana",
        "Isso aconteceu durante a Páscoa, quando o cordeiro era sacrificado",
        "A morte de Jesus pagou o salário do pecado"
      ]
    },

    48: {
      name: "O Sepultamento",
      challenge: "Descubra o sepultamento de Jesus",
      
      questions: {
        easy: {
          question: "Em qual túmulo Jesus foi colocado?",
          options: ["De Pedro", "De José de Arimateia", "De Nicodemos", "De Lázaro"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Em que o corpo de Jesus foi envolto?",
          options: ["Um manto púrpura", "Vestes douradas", "Um lençol branco", "Sem vestes"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "O que Nicodemos trouxe para o corpo de Jesus?",
          options: ["Óleo", "Mirra e aloés", "Água", "Flores"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "O túmulo estava escavado em uma rocha nova",
        "Uma grande pedra foi rolada para fechar a entrada",
        "Guardas foram posicionados para vigiar o túmulo"
      ],
      
      funFacts: [
        "Era o túmulo de um homem rico, cumprindo a profecia de Isaías",
        "O sepultamento foi feito às pressas porque o sábado estava chegando",
        "José era um discípulo secreto que se tornou corajoso"
      ]
    },

    49: {
      name: "O Túmulo Vazio",
      challenge: "Descubra a descoberta da manhã da ressurreição",
      
      questions: {
        easy: {
          question: "Quem encontrou primeiro o túmulo vazio?",
          options: ["Pedro", "João", "As mulheres", "Os soldados"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Onde estava a pedra?",
          options: ["Quebrada", "Rolada para o lado", "Ainda lá", "Desaparecida"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Quantos anjos as mulheres encontraram no túmulo?",
          options: ["Nenhum", "Um", "Dois", "Três"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Era a manhã do primeiro dia da semana",
        "As mulheres vieram para ungir o corpo de Jesus",
        "Os anjos anunciaram as boas novas"
      ],
      
      funFacts: [
        "As mulheres foram as primeiras testemunhas, um detalhe revolucionário",
        "Pedro e João correram até o túmulo",
        "O túmulo vazio sozinho não era suficiente, Jesus precisava aparecer"
      ]
    },

    50: {
      name: "Jesus Aparece a Maria Madalena",
      challenge: "Descubra a primeira aparição de Jesus",
      
      questions: {
        easy: {
          question: "A quem Jesus apareceu primeiro após a ressurreição?",
          options: ["Pedro", "João", "Maria Madalena", "Tomé"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Por quem Maria inicialmente confundiu Jesus?",
          options: ["Um anjo", "O jardineiro", "Um soldado", "Um fariseu"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "O que Jesus disse a Maria quando ela o reconheceu?",
          options: ["Vai e anuncia", "Não me toques", "Não temas", "Crê"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Maria estava chorando perto do túmulo",
        "Jesus a chamou pelo nome",
        "Ele a enviou para contar aos seus irmãos"
      ],
      
      funFacts: [
        "Jesus escolheu uma mulher para sua primeira aparição",
        "Maria se tornou a primeira apóstola",
        "Ela o chamou de 'Raboni' (Mestre)"
      ]
    },

    51: {
      name: "No Caminho de Emaús",
      challenge: "Descubra a aparição de Jesus na estrada",
      
      questions: {
        easy: {
          question: "Quantos discípulos estavam indo para Emaús?",
          options: ["Um", "Dois", "Três", "Quatro"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Quando os discípulos reconheceram Jesus?",
          options: ["Imediatamente", "Ao partir o pão", "Na estrada", "Nunca"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "O que Jesus explicou a eles no caminho?",
          options: ["O futuro", "As Escrituras", "A lei", "Os milagres"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Jesus caminhou com eles como um estranho",
        "Seus corações ardiam enquanto Ele falava",
        "Jesus desapareceu quando o reconheceram"
      ],
      
      funFacts: [
        "Emaús ficava a cerca de 11 km de Jerusalém",
        "Jesus mostrou-lhes como todas as Escrituras falavam sobre Ele",
        "Os discípulos imediatamente correram de volta para Jerusalém"
      ]
    },

    52: {
      name: "A Aparição aos Discípulos",
      challenge: "Descubra a aparição de Jesus na sala fechada",
      
      questions: {
        easy: {
          question: "Onde estavam os discípulos quando Jesus apareceu?",
          options: ["No templo", "No mercado", "Numa sala fechada", "No Getsêmani"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "O que Jesus mostrou aos discípulos?",
          options: ["Suas feridas", "Seu rosto", "Suas vestes", "Uma luz"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Qual discípulo estava ausente na primeira vez?",
          options: ["Pedro", "João", "Tomé", "Tiago"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "As portas estavam fechadas por medo",
        "Jesus disse 'Paz esteja convosco'",
        "Ele soprou sobre eles e disse 'Recebei o Espírito Santo'"
      ],
      
      funFacts: [
        "Jesus comeu com eles para provar que não era um fantasma",
        "Tomé acreditou uma semana depois",
        "Jesus apareceu muitas vezes durante 40 dias"
      ]
    }
  }
};
